import React, { useState } from 'react';
import Styles from './SeguroAuto25Cobertura.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import WhiteButton from '@/components/atoms/WhiteButton';
function SeguroAuto25Cobertura() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="seguro-auto-cobertura">
        {typeof window === 'undefined' ? (
          <></>
        ) : (
          <>
            {width < 992 && (
              <picture>
                <source
                  type="image/webp"
                  srcSet="assets/seguro-auto-25/cobertura/img-cobertura.webp"
                />
                <source
                  type="image/jpg"
                  srcSet="assets/seguro-auto-25/cobertura/img-cobertura.jpg"
                />
                <img
                  src="assets/seguro-auto-25/cobertura/img-cobertura.jpg"
                  alt="Mulher sorridente ao lado de um carro usando tablet, simbolizando praticidade na contratação de seguro de automóvel com a Santander Financiamentos."
                  className="img-cobertura"
                />
              </picture>
            )}
          </>
        )}
        <ContainerHome24>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width >= 992 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/seguro-auto-25/cobertura/img-cobertura-desk.webp"
                  />
                  <source
                    type="image/jpg"
                    srcSet="assets/seguro-auto-25/cobertura/img-cobertura-desk.jpg"
                  />
                  <img
                    src="assets/seguro-auto-25/cobertura/img-cobertura-desk.jpg"
                    alt="Mulher sorridente ao lado de um carro usando tablet, simbolizando praticidade na contratação de seguro de automóvel com a Santander Financiamentos."
                    className="img-cobertura"
                  />
                </picture>
              )}
            </>
          )}
          <div className="cobertura-contain">
            <h2 className="cobertura-titulo">O que o seguro Santander Auto vai cobrir?</h2>
            <ul className="coberturas">
              <div>
                <li>Carro reserva</li>
                <li>Roubo</li>
                <li>Colisão</li>
              </div>
              <div>
                <li>Danos a terceiros</li>
                <li>Vidros</li>
              </div>
            </ul>
            <p className="cobertura-texto">
              Conheça o canal da Santander Auto no Youtube para ficar por dentro de todas as
              novidades.
            </p>
            <WhiteButton
              href="https://www.youtube.com/c/SantanderAuto"
              target="_blank"
              className="btn-cobertura"
            >
              Saiba mais
            </WhiteButton>
          </div>
        </ContainerHome24>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default SeguroAuto25Cobertura;
